import { FeatureFlagName } from '@api'
import { useUnit } from 'effector-react'

import { Page } from '@/components/layout/page/page.tsx'
import { DefaultPageSkeleton } from '@/components/ui/default-page-skeleton'
import { Separator } from '@/components/ui/separator'
import { $isCreatorProcessCompleted } from '@/models/creators.ts'
import { $availableFeatures } from '@/models/feature-flags.ts'
import { useAiTranslatorToggle } from '@/modules/ai-features/components/ai-translator-toggle/use-ai-translator-toggle.ts'
import { isFeatureAvailable as isFeatureAvailableUtil } from '@/utils/featureFlags.ts'

import { AiTranslatorToggle } from '../components/ai-translator-toggle/ai-translator-toggle'
import { SmartGlossary } from '../components/smart-glossary/smart-glossary'
import { TextSettings } from '../components/text-settings/text-settings'
import { TypoSettings } from '../components/typo-settings/typo-settings'

export const AiSettings = () => {
  const isCreatorProcessCompleted = useUnit($isCreatorProcessCompleted)
  const { enabled } = useAiTranslatorToggle()
  const availableFeatures = useUnit($availableFeatures)

  const isFeatureAvailable = isFeatureAvailableUtil(
    availableFeatures,
    FeatureFlagName.PREMIUM_AI_TRANSLATION_MODEL_FEATURE_FLAG,
  )

  if (!isCreatorProcessCompleted) {
    return <DefaultPageSkeleton />
  }

  return (
    <Page>
      <div className="flex flex-col gap-[32px]">
        <AiTranslatorToggle key="ai-settings-toggle" />
        {enabled && (
          <>
            <Separator />
            {isFeatureAvailable && (
              <>
                <TextSettings />
                <Separator />
                <SmartGlossary />
                <Separator />
                <TypoSettings />
              </>
            )}
          </>
        )}
      </div>
    </Page>
  )
}
